import {fetchActions, pureActions} from "../factories/actions";
import {fetchLocations} from "../factories/locations";

// const mockHistory =
//   ["I1", "D1", "D2", "C1", "C2", "C3", "C4", "C5", "C6", "T1", "T2", "T3", "T4", "T5", "T6", "T7", "E1", "E2", "E3", "R1", "R3", "R4", "R5"]
  //   // ["I1", "D2", "C1", "T1", "C2", "C3", "C4", "C5", "C6", "T2", "T5", "T3", "T6", "T7", "E1", "E2", "R3", "R5", "TP5", "TP3", "E3", "D1", "E4", "R2", "R3", "TP4", "TP2", "TP3", "TP4",]
//   ["I1", "D1", "D2", "C1", "T1", "C2", "C3", "C4", "C5", "C6", "T2", "T5", "T3", "T6", "T7", "E1", "E2", "R3", "R5", "TP5", "TP3"]
//   .map(each => pureActions.find(action => action.id === each));

const initialState = {
  collection: [],
  // line after this comment will create some mock user actions;
  // tweak as desired for testing of unique cases;
  // history: fetchActions(fetchActions(), fetchLocations()),
  // history: mockHistory,
  history: [],
};

export default function reducer(
  state = {
    ...initialState
  },
  action
) {
  switch (action.type) {
    case "FETCH_ACTIONS":
      return {
        ...state,
        collection: fetchActions(action.data.history, action.data.locations),
      };

    case "TAKE_ACTION_FULFILLED":
      return {
        ...state,
        history: [...state.history, action.data.action],
      };

    case "RESET":
    case "LOGOUT":
      return {
        ...initialState,
      };

    default:
      return state;
  }
}
